<template>
	<div class="upsell-item">
		<a
			:href="url"
			class="grid-view-item__link grid-view-item__image-container"
			:title="`Product: ${title}`"
			:aria-label="`Product: ${title}`"
			@mouseover="hover = $screen.laptop_up"
			@mouseleave="hover = false">
			<div class="grid-view-item__image-wrapper">
				<img
					:src="activeImage.src"
					data-sizes="auto"
					class="vimg lazyload"
					:alt="activeImage.alt"
					@lazyloaded="$emit('loaded')" />
			</div>
		</a>
		<div class="select-variants">
			<transition name="fade">
				<ul class="upsell-variant" v-show="openVariantSelect">
					<li
						v-for="variant in variantsList"
						:key="variant.variantId"
						@click="addToCart(variant.variantId)"
						:class="{
							active: checkVariantActive(variant.variantId),
							notAvailable: variant.available,
						}">
						<h6>{{ variant.title }}</h6>
					</li>
				</ul>
			</transition>
			<div
				class="upsell-add"
				@click="openVariantSelect = !openVariantSelect">
				<h6 v-if="!active">Add</h6>
				<h6 v-else>Added <span v-html="checkIcon"></span></h6>

				<span v-if="!openVariantSelect">+</span>
				<span v-else>-</span>
			</div>
		</div>
		<p class="h5 grid-view-item__title">
			{{ title }}
		</p>
		<p class="h6 grid-view-item__meta">
			<span class="product-price__price" v-text="$money(price)"></span>
			<s
				v-if="salePrice"
				class="visually-hidden"
				v-text="$money(salePrice)"></s>
		</p>
	</div>
</template>

<style>
.upsell-item .select-variants {
	position: relative;
}
.upsell-item .upsell-variant {
	position: absolute;
	bottom: 46px;
	width: 100%;
	padding: 35px 35px 5px 35px;
	background: white;
}
.upsell-item .upsell-variant li {
	text-align: center;
	border-bottom: 1px #e4e4e4 solid;
}
.upsell-item .upsell-variant li.active h6 {
	font-weight: 600;
}
.upsell-item .upsell-variant li:last-of-type {
	border-bottom: none;
}
.upsell-item .upsell-variant li h6 {
	line-height: 28px;
	margin: 0;
}
.upsell-item .upsell-add {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	padding-block: 15px 10px;
	border-bottom: 1px black solid;
	cursor: pointer;
}
</style>

<script>
const axios = require('axios').default;

export default {
	name: 'UpsellItem',
	props: ['product'],
	data() {
		return {
			active: false,
			featuredLazyLoaded: false,
			imageSize: '550x',
			hover: false,
			key: 0,
			lazyloaded: 0,
			openVariantSelect: false,
			selectedVariants: [],
		};
	},

	computed: {
		title() {
			return this.product.title;
		},
		handle() {
			return this.product.handle;
		},
		price() {
			return this.variantsList[0].price;
		},
		salePrice() {
			return this.variantsList[0].compareAtPriceV2
				? this.variantsList[0].compareAtPriceV2.amount
				: '';
		},
		url() {
			return `/products/${this.handle}`;
		},
		images() {
			return this.product.media.edges[0].node;
		},
		activeImage() {
			return this.images.image;
		},
		variantsList() {
			return this.product.variants.edges.map((item) => {
				const variantId = atob(item.node.id).split('/').pop();
				return { ...item.node, variantId };
			});
		},
		checkIcon() {
			return `<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12.9766 0.648438C13.332 0.976562 13.332 1.55078 12.9766 1.87891L5.97656 8.87891C5.64844 9.23438 5.07422 9.23438 4.74609 8.87891L1.24609 5.37891C0.890625 5.05078 0.890625 4.47656 1.24609 4.14844C1.57422 3.79297 2.14844 3.79297 2.47656 4.14844L5.34766 7.01953L11.7461 0.648438C12.0742 0.292969 12.6484 0.292969 12.9766 0.648438Z" fill="black"/>
								<path d="M12.9766 0.648438L12.7561 0.851922L12.7643 0.860739L12.7731 0.868879L12.9766 0.648438ZM12.9766 1.87891L12.7729 1.65829L12.7644 1.66677L12.9766 1.87891ZM5.97656 8.87891L5.76426 8.6666L5.75612 8.67542L5.97656 8.87891ZM4.74609 8.87891L4.96671 8.67526L4.95823 8.66677L4.74609 8.87891ZM1.24609 5.37891L1.4584 5.1666L1.44958 5.15847L1.24609 5.37891ZM1.24609 4.14844L1.44958 4.36888L1.4584 4.36074L1.46653 4.35192L1.24609 4.14844ZM2.47656 4.14844L2.25595 4.35208L2.26443 4.36057L2.47656 4.14844ZM5.34766 7.01953L5.13552 7.23166L5.3472 7.44334L5.55933 7.23212L5.34766 7.01953ZM11.7461 0.648438L11.958 0.861212L11.9665 0.851922L11.7461 0.648438ZM12.7731 0.868879C12.9999 1.07821 12.9999 1.44913 12.7731 1.65847L13.18 2.09935C13.6642 1.65243 13.6642 0.87491 13.18 0.427996L12.7731 0.868879ZM12.7644 1.66677L5.76443 8.66677L6.18869 9.09104L13.1887 2.09104L12.7644 1.66677ZM5.75612 8.67542C5.54679 8.9022 5.17587 8.9022 4.96653 8.67542L4.52565 9.08239C4.97257 9.56655 5.75009 9.56655 6.197 9.08239L5.75612 8.67542ZM4.95823 8.66677L1.45823 5.16677L1.03396 5.59104L4.53396 9.09104L4.95823 8.66677ZM1.44958 5.15847C1.2228 4.94913 1.2228 4.57821 1.44958 4.36888L1.04261 3.928C0.558453 4.37491 0.558453 5.15243 1.04261 5.59935L1.44958 5.15847ZM1.46653 4.35192C1.67587 4.12514 2.04679 4.12514 2.25612 4.35192L2.697 3.94495C2.25009 3.4608 1.47257 3.4608 1.02565 3.94495L1.46653 4.35192ZM2.26443 4.36057L5.13552 7.23166L5.55979 6.8074L2.68869 3.93631L2.26443 4.36057ZM5.55933 7.23212L11.9578 0.861023L11.5344 0.435852L5.13598 6.80695L5.55933 7.23212ZM11.9665 0.851922C12.1759 0.625141 12.5468 0.625141 12.7561 0.851922L13.197 0.444953C12.7501 -0.0392033 11.9726 -0.0392033 11.5257 0.444953L11.9665 0.851922Z" fill="white"/>
							</svg>`;
		},
	},

	methods: {
		addToCart(id) {
			this.selectedVariants = [...this.selectedVariants, id];
			window.localStorage.setItem(
				'variants',
				JSON.stringify(this.selectedVariants)
			);
			const config = {
				method: 'post',
				url: '/cart/add.js',
				data: {
					id,
					quantity: 1,
				},
			};
			axios(config).then(() => {
				window.location.reload();
			});
		},
		checkVariantActive(id) {
			return this.selectedVariants.filter((variant) => variant === id)
				.length;
		},
	},
	created() {
		if (window.localStorage.getItem('variants'))
			this.selectedVariants = JSON.parse(
				window.localStorage.getItem('variants')
			);

		this.active = this.variantsList.some((variant) => {
			const id = variant.variantId;
			return this.selectedVariants.filter((variant) => variant === id)
				.length;
		});
	},
};
</script>
